<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/colaboradores">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Email" v-model="dataset.data.email" required
                                                :rules="[$rules.required, $rules.email]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="CPF" v-model="dataset.data.registration" required
                                                :rules="[$rules.required, $rules.cpf]" v-mask="$masks.cpf" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-select dense label="Tipo" v-model="dataset.data.type" required
                                                :items="dataset.employeeTypes" item-text="name" item-value="id" outlined
                                                hide-details="auto">
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-select dense label="Cargo e permissões" v-model="dataset.data.role" required
                                                :rules="[$rules.required]" :items="dataset.roles" item-text="name"
                                                item-value="id" outlined hide-details="auto">
                                            </v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input dense accept="image/png, image/jpeg" prepend-icon="" outlined
                                                counter :rules="[$rules.fileSize(2)]"
                                                hint="O arquivo não pode ser superior a 2MB" hide-details="auto"
                                                label="Imagem" :clearable="true" @change="onFileSelected($event)"
                                                ref="file">
                                            </v-file-input>

                                            <v-img v-if="dataset.data.document_url"
                                                @click="openDoc(dataset.data.document_url)" class="rounded-xl"
                                                :height="100" :width="100" :src="dataset.data.document_url">
                                            </v-img>

                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import string from "@/common/util/string"

import axios from "axios"

import employeeTypes from "@/common/data/employee-types.data"


export default {
    name: "PostDetails",

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            data: {
            },
            employeeTypes: employeeTypes,
            roles: [],
        },

        selectedDoc: null,
        dialogViewDoc: false,

        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

    }),

    created() {
        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/colaboradores");
        },


        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.loadRoles();
            await this.load();
        },

        openDoc(cover) {
            this.selectedDoc = cover;
            this.dialogViewDoc = true;
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo colaborador' : 'Detalhes do colaborador'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Colaboradores",
                disabled: false,
                to: "/colaboradores",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/employees/${this.$route.params.id}`);
                console.log('result ', result)

                const data = result.data.content;

                this.dataset.data = data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadRoles() {
            try {
                const result = await axios.get('/api/v1/roles', { params: { limit: 100 } });
                this.dataset.roles = (result.data.content && result.data.content.data) || [];
            } catch (error) {
                this.dataset.roles = [];
            }
        },


        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o colaborador?',
                title: 'Incluir colaborador',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v1/employees', payload);

                this.$dialog.notify.info("Colaborador adicionado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do colaborador?',
                title: 'Atualizar colaborador',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/employees/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Colaborador atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.updateLoading = false;
            }
        },


        // buildPayload() {

        //     const data = {
        //         name: this.dataset.data.name,
        //         email: this.dataset.data.email,
        //         registration: this.dataset.data.registration,
        //         type: this.dataset.data.type
        //     }

        //     return data;

        // },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.email)
                formData.append('email', this.dataset.data.email);

            if (this.dataset.data.registration)
                formData.append('registration', string.sanitizeCpfCnpj(this.dataset.data.registration));

            if (this.dataset.data.type)
                formData.append('type', this.dataset.data.type);

            if (this.dataset.data.role)
                formData.append('role', this.dataset.data.role);

            if (this.dataset.data.file)
                formData.append('document', this.dataset.data.file)

            return formData;
        },


        // buildPayload() {
        //     const formData = new FormData()

        //     if (this.dataset.data.name)
        //         formData.append('name', this.dataset.data.name);

        //     if (this.dataset.data.email)
        //         formData.append('email', this.dataset.data.email);

        //     if (this.dataset.data.description)
        //         formData.append('description', this.dataset.data.description);

        //     if (this.dataset.data.file)
        //         formData.append('file', this.dataset.data.file)

        //     return formData;
        // },

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
